module.exports = __webpack_public_path__ + "img/tyson_oxnvpp.721ca3be.png";